export default __webpack_public_path__ + "static/media/330_dummy2016-heilpraxis01-de.3618bf86.png";